import { MonetizationType, PresentationType } from '@/@types/graphql-types';

export enum TitleObjectType {
	MOVIE = 'movie',
	SHOW = 'show',
	SEASON = 'show_season',
	EPISODE = 'show_episode',
	PERSON = 'person',
	LEAVING_SOON = 'leaving_soon',
	SPORTS_GAME = 'sports_game',
}

export enum PopularTabType {
	MOVIE = 'movie',
	SHOW = 'show',
	ALL = 'overview',
}

// list of presentation types actually returned by the backend
export const PresentationTypes = [
	{
		value: PresentationType['4K'],
		label: '4K',
		isQuality: true,
	},
	{
		value: PresentationType.Hd,
		label: 'HD',
		isQuality: true,
	},
	{
		value: PresentationType.Sd,
		label: 'SD',
		isQuality: true,
	},
	{
		value: PresentationType.Dvd,
		label: 'DVD',
	},
	{
		value: PresentationType.Bluray,
		label: 'Blu-ray',
	},
];

interface MonetizationTypeInterface {
	label: string;
	/** might be used for sorting */
	priority: number;
	value: MonetizationType;
	/** false value should not be shown when possible */
	visible: boolean;
}

export const MonetizationTypes: MonetizationTypeInterface[] = [
	{
		label: 'WEBAPP_ADS',
		priority: 2000,
		value: MonetizationType.Ads,
		visible: true,
	},
	{
		label: 'WEBAPP_BUY',
		priority: 4000,
		value: MonetizationType.Buy,
		visible: true,
	},
	{
		label: 'WEBAPP_FLATRATE',
		priority: 3000,
		value: MonetizationType.Flatrate,
		visible: true,
	},
	{
		label: 'WEBAPP_FLATRATE',
		priority: 3000,
		value: MonetizationType.FlatrateAndBuy,
		visible: false,
	},
	{
		label: 'WEBAPP_RENT',
		priority: 4000,
		value: MonetizationType.Rent,
		visible: true,
	},
	{
		label: 'WEBAPP_FREE',
		priority: 1000,
		value: MonetizationType.Free,
		visible: true,
	},
];
